import type {UntypedPayload} from 'constants/events/EventPayloadUtils';

export const PROCESS_MANAGEMENT_EVENT_PAYLOADS = {
  PROCESS_MANAGEMENT_ITEMS_UPDATED: {} as UntypedPayload,
} as const;

export type ProcessManagementEventPayload = typeof PROCESS_MANAGEMENT_EVENT_PAYLOADS;
